import { Pipe, PipeTransform } from '@angular/core';
import { getBlobUrl } from '../_helpers/blob-url.helper';

@Pipe({ name: 'blobUrl', pure: true })
export class BlobUrlPipe implements PipeTransform {
  transform(path: string | null | undefined, container: string): string {
    return getBlobUrl(container, path);
  }
}
